<div class="space-y-6">
  <div class="flex items-center justify-between">
    <app-page-headline
      [headline]="'pages.snapshots.headline' | translate"
      [isLoading]="isLoading"
      [count]="total"
    />
  </div>

  <div class="flex flex-col gap-6">
    <app-search-box
      data-test-id="searchBox"
      class="w-80"
      [isLoading]="isLoading"
      (changeSearch)="onSearchFilterChange($event)"
    />
    <app-table
      [customNoResultText]="'pages.snapshots.noResultText' | translate"
      [tableColumns]="[
        {
          key: 'createdAt',
          label: 'models.snapshot.createdAt.label' | translate,
          width: '180px',
          cellTemplate: dateCellTemplate,
          sort: true,
        },
        {
          key: 'createdBy',
          label: 'models.snapshot.createdBy.label' | translate,
          width: '250px',
          cellTemplate: userCellTemplate,
          sort: true,
        },
        {
          key: 'name',
          label: 'models.snapshot.name.label' | translate,
          width: '180px',
          cellTemplate: markedCellTemplate,
          sort: true,
        },
        {
          key: 'note',
          label: 'models.snapshot.note.label' | translate,
          width: '350px',
          cellTemplate: markedCellTemplate,
          sort: true,
        },
        {
          key: 'actions',
          label: 'pages.snapshots.tableActions.label' | translate,
          width: '96px',
          align: 'right',
          fixRight: true,
          cellTemplate: actionCellTemplate,
          sort: false,
        },
      ]"
      [tableData]="tableData"
      [total]="total"
      [pageSize]="pageSize"
      [pageIndex]="pageIndex"
      [isLoading]="isLoading"
      [defaultSorting]="this.activeSorting"
      (changeHandler)="changeTableHandler($event)"
    />
  </div>
</div>

<ng-template #dateCellTemplate let-item="item" [typedTemplate]="typeToken">
  {{ item | date: 'dd.MM.yyyy - HH:mm:ss' }}
</ng-template>

<ng-template #userCellTemplate let-item="item" [typedTemplate]="typeToken">
  <app-user [userMail]="item" [highlight]="sword" />
</ng-template>

<ng-template #markedCellTemplate let-item="item" [typedTemplate]="typeToken">
  <div [innerHTML]="item | highLightText: sword"></div>
</ng-template>

<ng-template
  #actionCellTemplate
  let-currentRow="currentRow"
  [typedTemplate]="typeToken"
>
  <div class="flex gap-2">
    <app-button
      class="inline-block"
      data-test-id="viewButton"
      type="primary"
      shape="circle"
      [title]="'pages.snapshots.tableActions.view.title' | translate"
      [routerLink]="['snapshot-detail', currentRow.id]"
    >
      <svg-icon src="assets/icons/General/eye.svg" />
    </app-button>
    <app-button
      class="inline-block"
      data-test-id="downloadButton"
      type="primary"
      shape="circle"
      [title]="'pages.snapshots.tableActions.download.title' | translate"
      (trigger)="download(currentRow.id)"
    >
      <svg-icon src="assets/icons/General/download-01.svg" />
    </app-button>
  </div>
</ng-template>
